// extracted by mini-css-extract-plugin
export default {"inputLabel":"Label_inputLabel__EvwSO"};